/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgentCodeRequest } from '../../models/agent-code-request';
import { AgentCodeResponse } from '../../models/agent-code-response';

export interface PostApiAgentV1GenerateCode$Json$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
  
    /**
     * The request payload for agent code generation.
     */
    body?: AgentCodeRequest
}

export function postApiAgentV1GenerateCode$Json(http: HttpClient, rootUrl: string, params?: PostApiAgentV1GenerateCode$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentCodeResponse>> {
  const rb = new RequestBuilder(rootUrl, postApiAgentV1GenerateCode$Json.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentCodeResponse>;
    })
  );
}

postApiAgentV1GenerateCode$Json.PATH = '/private/v1/agents/generate-code';
